<template>
    <b-form-select v-model="provinceProduct.warranty_codice"
                   :options="warrantiesOpt()"
                   size="sm"
    />
</template>
<script>

import store from "./store";

export default {
    name: 'select-warranty',
    props: {
        provinceProduct: {},
        provinceProducts: {},
        province: {
            type: String,
            required: true,
        },
    },
    methods: {
        warrantiesOpt() {
            const product = store.products.find(p => p.value === this.provinceProduct.tariffa_codice)
            let warranties = product?.warranties ?? []

            if (!warranties.length) return warranties

            //filter by parent profile
            if (store.parentProfile) {
                const parentProvince = store.parentProfile.province_abilitate[this.province] ?? []
                const parentWarranties = parentProvince
                    .filter(p => p.tariffa_codice === this.provinceProduct.tariffa_codice)
                    .map(i => i.warranty_codice)
                warranties = warranties.filter(i => parentWarranties.includes(i.value))
            }

            const alreadySelected = this.provinceProducts
                .filter(p => p.tariffa_codice === this.provinceProduct.tariffa_codice)
                .reduce((acc, p) => {
                    if (p.warranty_codice !== this.provinceProduct.warranty_codice) {
                        acc.push(p.warranty_codice)
                    }
                    return acc
                }, [])

            return warranties.filter(w => !alreadySelected.includes(w.value))
        }
    }
}
</script>
